import { useEffect, useRef } from 'react';
import { useToolbarUI } from '../hooks/ui-context';
export var ACTION_SUBJECT = {
  TOOLBAR: 'toolbar',
  TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
export var ViewEventEmitter = function ViewEventEmitter(_ref) {
  var actionSubjectId = _ref.actionSubjectId,
    actionSubject = _ref.actionSubject;
  var isMountedRef = useRef(false);
  var _useToolbarUI = useToolbarUI(),
    fireAnalyticsEvent = _useToolbarUI.fireAnalyticsEvent;
  useEffect(function () {
    if (isMountedRef.current) {
      return;
    }
    isMountedRef.current = true;
    var payload = {
      action: 'viewed',
      actionSubject: actionSubject,
      actionSubjectId: actionSubjectId,
      eventType: 'ui'
    };
    fireAnalyticsEvent && fireAnalyticsEvent(payload);
  }, [actionSubjectId, actionSubject, fireAnalyticsEvent]);
  return null;
};